var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkItem',{ref:"editor",attrs:{"options":_vm.options,"chooseParam":_vm.options.chooseParam,"value":_vm.propValue,"propReadonly":_vm.readonly,"chooseEventScope":_vm.form},on:{"change":_vm.changeHandle,"itemClick":_vm.itemClickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }